module.exports = __webpack_public_path__ + "static/img/wf.732915ef.svg";